var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data['type'])?_c('span',[_vm._v("\n  "+_vm._s(_vm.data['type']['name'])+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }